import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LandingPage from './component';
import { goToProfile } from '../../actions';

const mapStateToProps = state => (
  {
    authenticated: state.user.authenticated,
    done: state.survey.done,
    users: state.feed.users,
  }
);

export default connect(mapStateToProps, { goToProfile })(withRouter(LandingPage));
